import { render, staticRenderFns } from "./ProgressCircular.vue?vue&type=template&id=5628a119&scoped=true&"
import script from "./ProgressCircular.vue?vue&type=script&lang=ts&"
export * from "./ProgressCircular.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressCircular.vue?vue&type=style&index=0&id=5628a119&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628a119",
  null
  
)

export default component.exports